import { useTranslation } from 'react-i18next';
import { Badge } from '@components/badge';
import { BADGE_VARIANT_GREEN, BADGE_VARIANT_RED } from '@components/badge/badge.type';
import { IconTicket } from '@components/icons/icon-ticket';
import { MAGIC_SEARCH_BOOKING_STATUS_ACTIVE } from '@domain/magic-search';
import classNames from 'classnames';
import { Command } from 'cmdk';

import { MAGIC_SEARCH_ITEM_CLASS } from '../constants';
import { MagicSearchBookingItemProps } from '../magic-search-palette.type';
import { formatBookingTotal } from '../utils/format-booking-total';
import { formatResultDate } from '../utils/format-result-date';
import { getBookingRoute } from '../utils/get-booking-route';

import { MagicSearchItemMedia } from './magic-search-item-media';
import { MagicSearchItemText } from './magic-search-item-text';

export const MagicSearchBookingItem = ({ booking, onOpen }: MagicSearchBookingItemProps) => {
  const { t, i18n } = useTranslation();
  const route = getBookingRoute(booking);
  const eventDate = formatResultDate(booking.event.startingTime, booking.event.timezone, i18n.language);
  const isActive = booking.status === MAGIC_SEARCH_BOOKING_STATUS_ACTIVE;

  return (
    <Command.Item
      value={`booking:${booking.id}`}
      disabled={!route}
      onSelect={() => route && onOpen(route)}
      className={classNames(MAGIC_SEARCH_ITEM_CLASS, { 'opacity-50': !route })}
      data-testid={`magic-search--result-booking-${booking.id}`}>
      <MagicSearchItemMedia Icon={IconTicket} />
      <MagicSearchItemText
        title={booking.fullName ?? booking.email ?? ''}
        legacyId={booking.legacyId}
        lines={[
          [booking.fullName ? booking.email : null, booking.event.name, eventDate],
          [
            t('menu:magicSearchTickets', { count: booking.tickets }),
            formatBookingTotal(booking),
            booking.company?.name,
          ],
          [route ? null : t('menu:magicSearchNotAvailable')],
        ]}
      />
      <Badge
        variant={isActive ? BADGE_VARIANT_GREEN : BADGE_VARIANT_RED}
        dataTestId={isActive ? 'magic-search-booking--active' : 'magic-search-booking--cancelled'}>
        {t(isActive ? 'eventReport:activeLabel' : 'eventReport:cancelledLabel')}
      </Badge>
    </Command.Item>
  );
};
